import { render } from "./WhyWe.vue?vue&type=template&id=5902f521"
import script from "./WhyWe.vue?vue&type=script&lang=js"
export * from "./WhyWe.vue?vue&type=script&lang=js"
script.render = render

export default script